import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { HelperService } from '../../core/services/helper.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HomeComponent {
  private readonly helperService = inject(HelperService);

  constructor() {
    this.helperService.setTitle(null, ' ');
  }
}
